
export const classesObjectToString = (object): string => {
    return Object.keys(object)
        .filter(key => object[key])
        .join(" ");
};



// WEBPACK FOOTER //
// ./src/core/helpers/classes-object-to-string.ts